import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';

import App from './App';
import { AuthAvailabilityContext } from './auth/authAvailability';
import { createMsalInstance } from './auth/msal';
import ErrorBoundary from './components/ErrorBoundary';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/app.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root was not found in index.html');

// MSAL reads its provider options from /appsettings.json at runtime, so the
// first render waits on that fetch — the loader markup in index.html is what
// the visitor sees until then.
void createMsalInstance().then((msalInstance) => {
  const tree = (
    <StrictMode>
      <ErrorBoundary>
        <AuthAvailabilityContext.Provider value={msalInstance !== null}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthAvailabilityContext.Provider>
      </ErrorBoundary>
    </StrictMode>
  );

  createRoot(container).render(
    msalInstance ? <MsalProvider instance={msalInstance}>{tree}</MsalProvider> : tree,
  );
});
